import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
import { useDeleteIdol, canDeleteIdol } from '@/hooks/useDeleteIdol';

import placeholder_portrait_200x200 from "@/assets/imgs/placeholders/portrait_200x200.jpg";
import placeholder_cover_1600x700 from "@/assets/imgs/placeholders/cover_1600x700.jpg";

import MainNav from '@/components/layout/AppNavbar';
import MessageModal from '@/components/ui/MessageModal';
import StatusModal from '@/components/ui/StatusModal';
import Loading from '@/components/ui/Loading';
import IdolCard from '@/components/ui/IdolCard';

function IdolList() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [deleteId, setdeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const idolList = useSelector(state => state.idol.list);
  const deleteIdolAndSwitch = useDeleteIdol();

  const modalDelete = useRef(null);
  const modal1000 = useRef(null);

  // API 非成功狀態碼統一由 StatusModal 顯示
  const statusModalRef = useRef(null);
  const [currentStatusCode, setCurrentStatusCode] = useState('');

  const deleteIdol = async() => {
    modalDelete.current.hide();
    setIsLoading(true);
    try {
      const statusCode = await deleteIdolAndSwitch(deleteId);
      if (statusCode === 'SYSTEM_1000') {
        modal1000.current.show();
      } else if (statusCode !== 'NETWORK_ERROR') {
        // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
        setCurrentStatusCode(statusCode);
        statusModalRef.current?.show();
      }
    } catch (error) {
      // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
      if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
        setCurrentStatusCode(error.httpErrorCode);
        statusModalRef.current?.show();
      } else if (!error.httpErrorCode) {
        console.error('Delete idol error:', error);
      }
    } finally {
      setIsLoading(false);
    }
  }

  const handleDeleteClick = (idolId) => {
    setdeleteId(idolId);
    modalDelete.current.show();
  };

  return <>
    <MainNav />
    <Container fluid="lg" className="idol-list nav-padding pb-4">
      <Row className="pt-4">
        <Col xs={12}>
          <h3 className="mb-4">{t('idollist')}</h3>
        </Col>
      </Row>

      {/* 創建偶像按鈕 */}
      <Row className="mb-4">
        <Col xs={12}>
          <div className="d-flex justify-content-end">
            <Button
              variant="primaryF"
              className="rounded-pill"
              href="/idol-create"
            >
              <FontAwesomeIcon icon={["fas", "plus"]} className="me-2" />
              {t('create_idol')}
            </Button>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <div className="cards-grid">
            {idolList.map((item) => (
              <IdolCard
                key={item.idol_id}
                idol={{
                  subscribed_idol_id: item.idol_id,
                  subscribed_idol_uuid: item.idol_uuid,
                  subscribed_idol_name: item.idol_nick_name,
                  subscribed_idol_is_official: item.idol_is_official,
                  subscribed_idol_avatar_url: item.idol_big_avatar_url || placeholder_portrait_200x200,
                  subscribed_idol_cover_url: item.idol_cover_url || placeholder_cover_1600x700
                }}
                showSubscriptionInfo={false}
                suspended={item.idol_is_suspended}
                toolbar={{
                  onEdit: item.idol_is_suspended ? undefined : () => navigate(`/idol-update/${item.idol_uuid}`),
                  onDelete: canDeleteIdol(item, idolList) ? () => handleDeleteClick(item.idol_id) : undefined
                }}
              />
            ))}
          </div>
        </Col>
      </Row>
    </Container>
    <MessageModal ref={ modalDelete } status="warning" size="md">
        <h5 className="mb-5">{t('delete_idol')} </h5>
        <div className="text-end">
          <button type="btn" className="btn btn-neutral rounded-pill me-3" onClick={ () => modalDelete.current.hide() }>{t('cancel')}</button>
          <button type="btn" className="btn btn-primary rounded-pill" onClick={ deleteIdol }>{t('confirm')}</button>
        </div>
    </MessageModal>
    <MessageModal ref={ modal1000 } status="success">
        <p>{t('delete_success')}</p>
    </MessageModal>
    <StatusModal ref={statusModalRef} statusCode={currentStatusCode} />
    {isLoading && <Loading></Loading>}
  </>

}

export default IdolList;